<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">Configuración clientes</h4>
				</div>
				<div class="modal-body">
					<loading :active="loading">
						<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
					</loading>
					<template v-if="setting">
						<div class="row">
							<div class="col-md-12">
								<table class="table table-responsive table-condensed table-hover table-striped">
									<tbody>
										<tr>
											<td>Referencia personalizada</td>
											<td>
												<div class="pull-right">
													<input @change="update()" type="checkbox" v-model="setting.custom_reference" class="js-switch pull-right" data-size="small">
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</template>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import VueElementLoading from 'vue-element-loading'
	export default {
		props: ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				modal: {
					selector: 'modal-setting-customers'
				},
				loading: false,
				setting: null,
			}
		},
		methods: {
			open() {
				this.init()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			init() {
				this.getData()
			},
			getData() {
				this.loading = true
				this.setting = null
				this.$http.get('admin/settings/customers')
				.then(response => {
					this.setting = response.body
					this.loading = false
					this.loadSwitchs()
				})
			},
			loadSwitchs() {
				this.$nextTick( () => {
					$('.js-switch').each(function() {
						new Switchery($(this)[0], $(this).data());
					})
				})
			},
			update() {
				this.loading = true
				this.$http.put('admin/settings/customers/' + this.setting.id, this.setting)
				.then(response => {
					this.loading = false
				})
				.catch(response => {
					console.log(response)
					this.loading = false
				})
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/views/Customers.vue